var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{staticClass:"multidimensional pt-4 pl-4 pr-4",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }